import React from 'react';
import { Coins } from 'lucide-react';
import { formatCurrency } from '../../../utils/currency';

interface ClosureHeaderProps {
  totalSalesToday: number;
  onCloseRegisterAction: () => void;
}

export function ClosureHeader({ totalSalesToday, onCloseRegisterAction }: ClosureHeaderProps) {
  return (
    <div className="rcv-header">
      <div>
        <h2 className="rcv-title">Arqueo y Cierre de Caja</h2>
        <p className="rcv-subtitle">Conciliación cuadre de caja de hoy • {new Date().toLocaleDateString('es-ES')}</p>
      </div>
      <div className="rcv-header-right">
        <div className="rcv-sales-badge">
          <span className="rcv-sales-label">Ventas del Día</span>
          <div className="rcv-sales-amount">
            <span>{formatCurrency(totalSalesToday)}</span>
          </div>
        </div>

        <button
          type="button"
          onClick={onCloseRegisterAction}
          className="rcv-close-btn"
        >
          <Coins style={{ width: '1.25rem', height: '1.25rem' }} />
          CERRAR CAJA DEFINITIVO
        </button>
      </div>
    </div>
  );
}
